import {client} from "@/store";

export default {
	namespaced: true,

	state: {
		companies: []
	},

	// sync actions
	mutations: {
		setCompanies(state, data) {
			if(this.state.companies.length > 0) {
				state.companies = this.state.companies.filter(company => { return company.id !== data.id; });
			}
			state.companies.push(data);
		}
	},

	// async actions
	actions: {
		fetchCompany({
			commit,
			state,
			dispatch
		}, data) {
			const query = `query ($id: Int!) {
				company(id: $id) {
					id
					companyname
					customernumber
				}
				}`;

			return new Promise((resolve, reject) => {
				commit('setLoading', null, { root: true });
				client.query(query, {...data}).then(result => {
					commit('setIdle', null, { root: true });
						commit("setCompanies", result.company);
						resolve(result.company);
					})
					.catch(error => {
						reject(error);
					});
			});
		},
	}
};
